import { useLocalization } from '@/hooks/localization'
import React, { useState } from 'react'
import getComponentKey from '@/utils/getComponentKey'
import { TdActions } from '@/components/tdActions'
import { Button } from '@/components/button'
import context from '@/context'
import { BsrsGrid, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import { GridColumn as Column } from '@progress/kendo-react-grid/dist/npm/GridColumn'
import LoadingIndicator from '@/components/LoadingIndicator'

const CbiIgnoredBlacklists = ({ personId }) => {
  const { localize } = useLocalization()
  const [gridKey, setGridKey] = useState(getComponentKey())
  const [isLoading, setIsLoading] = useState(false)

  const commandCell = ({ dataItem }) => {
    return <TdActions>
      <Button className='btn btn-sm' onClick={() => {
        setIsLoading(true)
        return context.api.blacklistRecordService.unIgnoreCbiBlacklistRecord({
          cbiBlacklistRecordId: dataItem.id,
          individualId: personId
        }).then(() => {
          setGridKey(getComponentKey())
        })
          .finally(() => setIsLoading(false))
      }} icon={'plus'} iconOnly />
    </TdActions>
  }

  return !isLoading ? <BsrsGrid
    name='cbiIgnoredBlacklists' inputType='grid' readonly
    lastReloadedAt={gridKey}
    dataSource={(request, opts) => context.api.blacklistRecordService.getIgnoredCbiBlacklistRecords(personId, request, opts)}>
    <Column field='codeId' title={localize('Individuals.CodeId')} />
    <Column field='nationalId' title={localize('Individuals.NationalId')} />
    <Column field='fullName' title={localize('Individuals.FullName')} />
    <Column field='motherName' title={localize('Individuals.MotherName')} />
    <Column field='validFrom' title={localize('Common.ValidFrom')} cell={DateCell} filterCell={DateFilterCell}
      filter='date' />
    <Column field='validTo' title={localize('Common.ValidTo')} cell={DateCell} filterCell={DateFilterCell}
      filter='date' />
    <Column cell={commandCell} filterable={false} editable={false} />
  </BsrsGrid> : <LoadingIndicator />
}

export { CbiIgnoredBlacklists }



// WEBPACK FOOTER //
// ./src/components/demographics/cbiIgnoredBlacklists.js